document.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-ajax-cart]");
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector("button[type='submit']");
  const original = button.textContent;
  button.disabled = true;
  button.textContent = "正在加入…";
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error("add failed");
    window.location.href = window.Shopify.routes.root + "cart";
  } catch (error) {
    button.disabled = false;
    button.textContent = original;
    alert("暫時未能加入購物袋，請稍後再試。");
  }
});

document.addEventListener("click", (event) => {
  const menuLink = event.target.closest(".mobile-menu nav a");
  if (!menuLink) return;
  menuLink.closest("details")?.removeAttribute("open");
});

document.querySelectorAll("[data-hero]").forEach((hero) => {
  const slides = [...hero.querySelectorAll("[data-hero-slide]")];
  const dots = [...hero.querySelectorAll("[data-hero-dot]")];
  if (slides.length < 2) return;

  let current = 0;
  let timer;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));
      slide.tabIndex = active ? 0 : -1;
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === current;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", String(active));
    });
  };

  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (!reduceMotion) timer = window.setInterval(() => show(current + 1), 5000);
  };

  dots.forEach((dot) => dot.addEventListener("click", () => {
    show(Number(dot.dataset.heroDot));
    start();
  }));
  hero.addEventListener("mouseenter", stop);
  hero.addEventListener("mouseleave", start);
  hero.addEventListener("focusin", stop);
  hero.addEventListener("focusout", start);
  show(0);
  start();
});

document.querySelectorAll("[data-media-marquee]").forEach((marquee) => {
  let inView = false;
  const sync = () => marquee.classList.toggle("is-paused", document.hidden || !inView);
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting;
      sync();
    }).observe(marquee);
  } else {
    inView = true;
  }
  document.addEventListener("visibilitychange", sync);
  sync();
});
